import React, { Component } from "react";
import { Form, Col, Row, Container } from "react-bootstrap";

export default class FormSelect extends Component {

  getSelectField = (isReadonlyField) => {
    if (isReadonlyField) {
      return <Form.Control as="select" defaultValue={this.props.formData} readOnly>
              {this.props.fieldModel.options.map((option, index) => {
                return (
                  <option key={index} value={option}>
                    {option}
                  </option>
                );
              })}
            </Form.Control>
    }
    else {
      return <Form.Control as="select" defaultValue={this.props.formData} onChange={this.props.onChange}>
              {this.props.fieldModel.options.map((option, index) => {
                return (
                  <option key={index} value={option}>
                    {option}
                  </option>
                );
              })}
            </Form.Control>
    }
  }

  render() {
    return (
      <Container>
        <Form.Group controlId={this.props.fieldModel.name} as={Row} >
            <Form.Label column sm={2} className="dynamicFormLabel">{this.props.fieldModel.label}</Form.Label>
            <Col sm={10}>
              {this.getSelectField(this.props.readOnly)}
            </Col>
        </Form.Group>
      </Container>
    );
  }
}

